<template>
    <div
        class="pb-1 text-center text-[11px] leading-[17px] font-medium text-gray-550"
        data-testid="sms-ai-disclaimer"
    >
        {{ $t('smsCommunication.aiDraft.disclaimer') }}
    </div>
</template>
